import angular from 'angular';

import EnhancedNavbarDirective from './enhanced_navbar.directive';
import EnhancedAdBuilderDirective from './enhanced_ad_builder.directive';
import EnhancedAdTableDirective from './enhanced_ad_table.directive';
import EnhancedAdExamplesDirective from './enhanced_ad_examples.directive';
import EnhancedAdExampleDirective from './enhanced_ad_example.directive';
import EnhancedAdShowDirective from './enhanced_ad_show.directive';

angular
  .module('generator.enhanced_ads', [])
  .directive('enhancedNavbar', EnhancedNavbarDirective)
  .directive('enhancedAdBuilder', EnhancedAdBuilderDirective)
  .directive('enhancedAdTable', EnhancedAdTableDirective)
  .directive('enhancedAdExamples', EnhancedAdExamplesDirective)
  .directive('enhancedAdExample', EnhancedAdExampleDirective)
  .directive('enhancedAdShow', EnhancedAdShowDirective);
